"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var inline_icon_1 = tslib_1.__importDefault(require("../../inline-icon/inline-icon"));
var ArrowRightIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/ArrowRightIcon"));
var button_scss_1 = tslib_1.__importDefault(require("./button.scss"));
var withStyles_1 = require("../../../../common/utils/withStyles");
var NavButton = function (_a) {
    var onClick = _a.onClick, arrowIcon = _a.arrowIcon, className = _a.className, ariaLabel = _a.ariaLabel, dataHook = _a.dataHook, tabIndex = _a.tabIndex, style = _a.style;
    return (react_1.default.createElement("button", { onClick: onClick, style: style, type: "button", className: classnames_1.default(className, button_scss_1.default.button), tabIndex: tabIndex, "aria-label": ariaLabel, "data-hook": dataHook }, arrowIcon));
};
NavButton.defaultProps = {
    arrowIcon: react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(ArrowRightIcon_1.default, null) }),
    tabIndex: 0,
};
exports.default = withStyles_1.withStyles(button_scss_1.default)(NavButton);
//# sourceMappingURL=button.js.map